import { useState, useEffect } from 'react';
import queryString from 'query-string';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import axios from 'axios';

function ResetPassword() {
    const parsed = queryString.parse(window.location.search);
    const accesstoken = parsed.accesstoken;
    const [email, setEmail] = useState(null);
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');
    const [ saving, setSaving ] = useState(false);
    const [ saveError, setSaveError ] = useState(false);
    const [ saveSuccess, setSaveSuccess ] = useState({show: false});

    useEffect(() => {
        window.document.body.classList.add('login');
        document.documentElement.classList.add('login');
    
        (async () => {
            const { data } = await axios(`/api/login?accesstoken=${accesstoken}`);
            setEmail(data.email);
        })();
        
        return () => {
            window.document.body.classList.remove('login');
            document.documentElement.classList.remove('login');
        }
    });

    async function onReset() {
        setSaving(true);
        try {
            const { data } = await axios.post(`/api/organizations/set-password?accesstoken=${accesstoken}`, { password });
            setSaveSuccess({...saveSuccess, show: true, message: `Password seat successfully. Redirecting you to login page...`});
            setSaveError(false);
            setSaving(false);
            setTimeout(() => window.location.href = `https://app.monada.ai/organization/${data.organizationAlias}`, 1000);
        } catch {
            setSaveError(true);
            setSaveSuccess({ ...saveSuccess, show: false });
            setSaving(false);
        }
    }

    function onSnackbarClose() {
        setSaveError(false);
        setSaveSuccess({ ...saveSuccess, show: false });
    }

    if (!email) {
        return (
            <div>
                &nbsp;
                <div style={{ position: 'fixed', top: 'calc(50% - 20px)', left: 'calc(50% - 20px)', width: '40px', height: '40px' }}>
                    <CircularProgress />
                </div>
            </div>
        )
    }

    return (
        <div>
            &nbsp;
            <Paper elevation={5} sx={{ position: 'fixed', top: 'calc(50% - 283px)', left: 'calc(50% - 200px)', width: '400px' }}>
                <img src='https://images.unsplash.com/photo-1493946740644-2d8a1f1a6aff?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2090&q=80' alt={'suppliers'} style={{ width: '400px' }}/>
                <div style={{ padding: '12px' }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Hi!
                    </Typography>

                    <Typography variant='body2' sx={{ textAlign: 'justify' }}>
                        You've reached this place since you asked to reset your password.
                        Please enter a new password for {email}: (we don't verify its strength, we trust you.)
                    </Typography>

                    <TextField
                        style={{ marginTop: '6px' }}
                        fullWidth
                        label='New Password'
                        type='password'
                        value={password}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setPassword(event.target.value);
                        }}
                    />
                    <TextField
                        style={{ marginTop: '6px' }}
                        fullWidth
                        label='Re-enter Password'
                        type='password'
                        value={password2}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setPassword2(event.target.value);
                        }}
                    />
                    <Button style={{ marginTop: '6px' }} fullWidth disabled={!password || password !== password2 || saving} variant='contained' color='primary' onClick={onReset}>
                        {saving ? <CircularProgress size={24} /> : 'Reset'}
                    </Button>
                </div>
            </Paper>
            <Snackbar open={saveError} autoHideDuration={6000} onClose={onSnackbarClose}>
                <Alert onClose={onSnackbarClose} severity='error' variant='filled' sx={{ width: '100%' }}>
                    Error saving. Please try again.
                </Alert>
            </Snackbar>
            <Snackbar open={saveSuccess.show} autoHideDuration={6000} onClose={onSnackbarClose}>
                <Alert onClose={onSnackbarClose} severity='success' variant='filled' sx={{ width: '100%' }}>
                    {saveSuccess.message}
                </Alert>
            </Snackbar>
        </div>
    );
}

export default ResetPassword;
